// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services

import { ApiService, SettingService } from '../../common/modules/core/services';

@Injectable()
export class VivaService {
    // Api Domain Url
    private apiUrl = '';
    private vivaUrl = '/vivafoods/vivafoods';
    private vivaTokenUrl = '/token.aspx?user=';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }
    
    getVivaToken(base64: any):Observable<any> {
        const requestUrl = this.vivaUrl + this.vivaTokenUrl + base64;
        return this.apiService.get<any>(requestUrl);
    }
}


// WEBPACK FOOTER //
// ./src/services/services/VivaService.ts